import btecStaking from "../abis/development/pools/btecStaking";

const host = "https://testnet.bscscan.com/address";

export default [
  {
    title: "BTEC Staking",
    contractAddress: "0x80414Feb5B08Db3Ab5aD595513EF7b61Cc01dc8b",
    abi: btecStaking.abi,
    minApr: 200,
    url: `${host}/0x80414Feb5B08Db3Ab5aD595513EF7b61Cc01dc8b`,
  },
];
